import React from 'react'
import UIkit from 'uikit'
import { connect } from 'react-redux'
import introJs from 'intro.js';

// components
import Modal from '../../../UIkit/Modal'

class ModalLessonTourEs extends React.Component {
  constructor(props) {
    super(props)

    this.handleStartLessonTour = this.handleStartLessonTour.bind(this)
  }

  handleStartLessonTour() {
    UIkit.modal('#modal-lesson-tour').hide()

    const steps = [
      {
        element: document.querySelectorAll('#skill-steps')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Instrucciones de la Lección</h4>
            <p>Esta area te guiará a través de cada uno de los pasos de la lección incluyendo instrucciones para poder realizar los ejercicios prácticos.</p>
            <p>Una vez que termines con el primer paso deberás hacer clic en el botón Siguiente, ubicado en la parte inferior, que te llevará a la próxima clase.</p>
          </div>
        `,
        tooltipPosition: 'right',
        position: 'right',
      }, {
        element: document.querySelectorAll('#browser')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Sandbox del navegador</h4>
            <p>Este panel es el entorno limitado del navegador y actúa muy similarmente a un navegador normal. Si le das clic al botón “View Source” puedes ver el código fuente del navegador. Se pueden encontrar muchas vulnerabilidades al ver el código front-end de una aplicación web. Para volver al navegador simplemente presiona “View Browser”</p>
          </div>
        `,
        position: 'left',
      }, {
        element: document.querySelectorAll('#proxy-intercept')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Intercept Requests</h4>
            <p>Para activar el proxy, asegúrate de que el botón “Intercept Requests” esté marcado. Esto mantendrá las peticiones HTTP enviadas en espera hasta que presiones el botón Enviar solicitud. Es una buena idea explorar aplicaciones web con la intercepción desactivada para que no te demore. Pero una vez que empieces a probar es una buena idea tenerlo activado para que puedas analizar las peticiones.</p>
          </div>
        `,
        position: 'bottom',
      }, {
        element: document.querySelectorAll('#proxy-status')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Proxy Status</h4>
            <p>El estado del proxy le indica si este está encendido o no. Haga clic en él para obtener más información sobre cada tipo de estado.</p>
          </div>
        `,
        position: 'bottom',
      }, {
        element: document.querySelectorAll('#proxy-request-button')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Proxy</h4>
            <p>Este botón expande la aplicación proxy que te permite ser el “man-in-the-middle” o el intermediario entre las peticiones y respuestas HTTP que van desde y hacia el navegador. La aplicación también se mostrará automáticamente si es que se intercepta una petición.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'left',
      }, {
        element: document.querySelectorAll('#proxy-history-button')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Historial de Proxy</h4>
            <p>La pestaña Historial del proxy muestra todas las peticiones y respuestas HTTP. Si haces click en el signo mas que se encuentra al costado de la petición HTTP podrás ver cada una de las peticiones y sus respuestas correspondientes. Esto es muy útil ya que te permite ver respuestas basadas en peticiones anteriores.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-code-div')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Editor de Código</h4>
            <p>El Editor de código te permite corregir el código vulnerable en el sandbox. Puedes cambiar el lenguaje de programación del código con el menú desplegable, y ver cualquier salida debajo del editor de texto.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-code-output-div')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Salida de Código y Errores</h4>
            <p>Esta pestaña te muestra impresa cualquier salida del código, lo que te puede ayudar a depurarlo. Funciona igual que la ventana de consola/terminal en tu entorno de desarrollo habitual.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-patches-div')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Historial de Parches</h4>
            <p>Esta pestaña te muestra el historial de todos los parches que has enviado. Muestra si fuiste o no capaz de corregir la vulnerabilidad con un determinado parche y el motivo del por qué falló.</p>
          </div>
        `,
        highlightClass: 'tour-dark',
        position: 'right',
      }, {
        element: document.querySelectorAll('#proxy-reset')[0],
        intro: `
          <div class="uk-padding-small">
            <h4>Reset Sandbox</h4>
            <p>Si logras romper la aplicación web en el browser del sandbox y quieres un nuevo inicio puedes presionar el botón Reset Sandbox que te generará una nueva aplicación web.</p>
          </div>
        `,
        position: 'bottom',
      },
    ]

    if (this.props.showCode === false) {
      steps.splice(6, 1)
    }

    const tour = introJs()
      .setOptions({
        skipLabel: 'Saltar Tour',
        showStepNumbers: false,
        hideNext: true,
        hidePrev: true,
        exitOnOverlayClick: false,
        disableInteraction: true,
        steps,
      })

    tour.start()
  }

  render() {
    return (
      <Modal
        id="modal-lesson-tour"
        titleTestId="title-modal-lesson-tour"
        title="Tour de clases de HackEDU"
        body={
          <div className="uk-text-center">
            <p>
              Este tour le guiará a través de los diferentes aspectos de nuestra interfaz de lecciones para la seguridad de aplicaciones web.
            </p>
            <div className="uk-margin">
              <button
                className="uk-button uk-button-primary uk-margin-right uk-margin-remove-bottom"
                style={{
                  padding: '0 30px',
                }}
                onClick={this.handleStartLessonTour}
              >
                Haz el Tour
              </button>
              <button
                className="uk-button uk-button-muted uk-margin-remove-bottom"
                style={{
                  padding: '0 30px',
                }}
                onClick={() => { UIkit.modal('#modal-lesson-tour').hide() }}
                data-test-id="btn-tour-start-the-lesson"
              >
                Comience la Lección
              </button>
            </div>
          </div>
        }
        containerModifier
      />
    )
  }
}

const mapStateToProps = state => ({
  replFlag: state.repl.flag,
})
export default connect(mapStateToProps)(ModalLessonTourEs)
